import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { tokenToPx } from './getToken';

export const dialogTheme = {
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: tokens.radiusMedium,
        minWidth: 450
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: tokenToPx('spacingXl')
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: tokenToPx('spacingXl')
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: tokenToPx('spacingXl'),
        '& button.MuiButtonBase-root': {
          marginLeft: tokenToPx('spacingXs')
        }
      }
    }
  }
} satisfies Components;
